module.exports = __webpack_public_path__ + "img/duiwu1.65cd2389.png";